<template>
  <v-card class="mt-2">
    <v-card-title>
      Tempo médio entre respostas (TMER)

      <v-spacer></v-spacer>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Pesquisar"
        single-line
        hide-details
      />
    </v-card-title>

    <v-card-text>
      <v-expand-transition>
        <v-progress-linear
          v-if="loading"
          indeterminate
        />
      </v-expand-transition>

      <v-expand-transition>
        <v-data-table
          class="elevation-2"
          no-data-text="Nenhum atendimento disponível"
          :search="search"
          :headers="headers"
          :items="loading ? [] : temposMediosEntreRespostas"
          :footer-props="{
            'items-per-page-text': 'Atendimentos por página',
            'page-text': '{0}-{1} de {2}',
            'items-per-page-all-text': 'Todos',
          }"
        >
          <template #item.agenteNome="{ item }">
            <td>
              <v-avatar
                :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
                size="32"
              >
                <span :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold`">
                  {{ item.agenteNome.toUpperCase().charAt(0) }}{{ item.agenteNome.toUpperCase().charAt(1) }}
                </span>
              </v-avatar>
              <span class="ms-2">
                {{ item.agenteNome }}
              </span>
            </td>
          </template>

          <template #item.protocolo="{ index, item }">
            <v-chip
              :color="index % 2 === 0 ? 'accent' : 'primary'"
              outlined
            >
              {{ item.protocolo }}
            </v-chip>
          </template>

          <template #item.tempoMedioEntreRespostas="{ item }">
            <td>
              <v-chip
                v-if="item.tempoMedioEntreRespostas"
                color="success"
                outlined
              >
                {{ formatTime(item.tempoMedioEntreRespostas) }}
              </v-chip>

              <v-tooltip
                v-else
                top
                color="warning"
              >
                <template #activator="{ on, attrs }">
                  <v-chip
                    color="warning"
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  >
                    Dados insuficientes
                  </v-chip>
                </template>
                <span>Ao menos duas mensagens são necessárias para fazer a média</span>
              </v-tooltip>
            </td>
          </template>

          <template #item.qtdMensagensAgente="{ index, item }">
            <td class="d-flex justify-center mr-5">
              <v-chip
                :color="index % 2 === 0 ? 'accent' : 'primary'"
                outlined
              >
                {{ item.qtdMensagensAgente }}
              </v-chip>
            </td>
          </template>
        </v-data-table>
      </v-expand-transition>
    </v-card-text>
  </v-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import { formatTime } from '@/utils/time'

export default {
  props: {
    temposMediosEntreRespostas: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  setup() {
    const headers = [
      { text: 'Agente', value: 'agenteNome' },
      { text: 'Protocolo', value: 'protocolo' },
      { text: 'Tempo médio entre respostas', value: 'tempoMedioEntreRespostas' },
      {
        text: 'Mensagens do agente', value: 'qtdMensagensAgente', align: 'center',
      },
    ]

    const search = ref('')

    return {
      headers,
      search,
      formatTime,
    }
  },
}
</script>
